import {
  ActivateInactivatePersonProfileUseCaseInterface,
  ActivateInactivatePersonUseCaseInterface,
  ChangePersonPasswordUseCaseInterface,
} from 'domain/usecases';
import { FormikValues } from 'formik';
import { notifyError, notifySuccess } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { useCallback, useState } from 'react';

export const usePersonRegisterTab = () => {
  const [loadingChangePassword, setLoadingChangePassword] =
    useState<boolean>(false);
  const [loadingActivateInactivate, setLoadingActivateInactivate] =
    useState<boolean>(false);
  const [
    loadingActivateInactivateProfile,
    setLoadingActivateInactivateProfile,
  ] = useState<boolean>(false);

  const { personService } = useService();

  const requestChangePersonPassword = useCallback(
    async (
      params: ChangePersonPasswordUseCaseInterface.Params,
      validation: FormikValues,
    ) => {
      setLoadingChangePassword(true);

      try {
        const res = await personService.changePersonPassword(params);
        notifySuccess(res.message);
        validation.resetForm();
      } catch (error) {
        if (error instanceof Error) {
          notifyError(error.message);
        }
      } finally {
        setLoadingChangePassword(false);
      }
    },
    [],
  );

  const requestActivateInactivatePerson = useCallback(
    async (
      params: ActivateInactivatePersonUseCaseInterface.Params,
      onSuccess: () => void,
    ) => {
      setLoadingActivateInactivate(true);

      try {
        const res = await personService.activateInactivatePerson(params);
        notifySuccess(res.message);
        onSuccess();
      } catch (error) {
        if (error instanceof Error) {
          notifyError(error.message);
        }
      } finally {
        setLoadingActivateInactivate(false);
      }
    },
    [],
  );

  const requestActivateInactivatePersonProfile = useCallback(
    async (
      params: ActivateInactivatePersonProfileUseCaseInterface.Params,
      onSuccess: () => void,
    ) => {
      setLoadingActivateInactivateProfile(true);

      try {
        const res = await personService.activateInactivatePersonProfile(params);
        notifySuccess(res.message);
        onSuccess();
      } catch (error) {
        if (error instanceof Error) {
          notifyError(error.message);
        }
      } finally {
        setLoadingActivateInactivateProfile(false);
      }
    },
    [],
  );

  return {
    loadingChangePassword,
    loadingActivateInactivate,
    loadingActivateInactivateProfile,
    requestChangePersonPassword,
    requestActivateInactivatePerson,
    requestActivateInactivatePersonProfile,
  };
};
